/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Project_Instructions_Q1_C6Inputs */



/**
* | output |
* | --- |
* | "Meeting notes and follow-ups" |
*
* @param {Uno_Field_Project_Instructions_Q1_C6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_project_instructions_q1_c6 = /** @type {((inputs?: Uno_Field_Project_Instructions_Q1_C6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Project_Instructions_Q1_C6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Besprechungsnotizen und To-dos")
	return /** @type {LocalizedString} */ ("Meeting notes and follow-ups")
});